module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.appointment && _vm.appointment.id) ? _c('v-card', {
    key: "client",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('appointment-list-item', {
    attrs: {
      "with-status-chips": "",
      "with-color-coding": false,
      "appointment": _vm.appointment
    }
  }, [_c('v-list-tile-action', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('appointment-action-menu', {
    attrs: {
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "action",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    },
    slot: "action"
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "dark": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.client) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("person")]), _vm._v("\n          Client ")], 1) : _vm._e(), _vm._v(" "), (_vm.appointment) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v("\n          Appointment ")], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.client) ? _c('v-tab-item', [_c('client-details', {
    attrs: {
      "value": _vm.client,
      "with-title": false,
      "is-compact": true,
      "with-fetch": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', [_c('appointment-card', {
    attrs: {
      "fetch": ""
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1)], 1)], 1)], 1) : _c('welcome', {
    key: "home",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "chart:appointments:clicked": _vm.bubble
    },
    model: {
      value: (_vm.homepage),
      callback: function($$v) {
        _vm.homepage = $$v
      },
      expression: "homepage"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3e535c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Detail.vue
// module id = 1461
// module chunks = 9